// export const ssr = false;
export const prerender = true;

export const ssr = false;
// export const prerender = false;
export const trailingSlash = 'always';